export default {
	escapeHtml(html) {
		if (!html) return '';
		return html
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	},
	unescapeHtml(html) {
		if (!html) return '';
		return html
			.replace(/&amp;/g, '&')
			.replace(/&lt;/g, '<')
			.replace(/&gt;/g, '>')
			.replace(/&quot;/g, '"')
			.replace(/&#039;/g, "'");
	},
	wrapLinks(html) {
		if (!html) return html;
		
		html = this.escapeHtml(html);
		html = html.replace(/(https?:\/\/[^\s"'(),]+)[^\.\s,]/gi, '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>');
		return html;
	},
	stripTags(html) {
		if (!html) return '';
		return html.replace(/<.*?>/g, '');
	}
}